import { TemplateConfig } from '../types';

export const heartVoiceSpreadConfig: TemplateConfig = {
  id: 'heart-voice-spread',
  name: '心之声牌阵',
  description: '分析你和对方之间的感情走向',
  cardCount: 8,
  
  fieldDefaults: {
    title: '心之声牌阵',
    customerQuestion: '分析我和对方之间的感情走向。',
    cardPlaceholders: [
      '请输入第 3 列第 1 张牌',
      '请输入第 3 列第 2 张牌',
      '请输入第 1 列第 1 张牌',
      '请输入第 5 列第 1 张牌',
      '请输入第 2 列第 1 张牌',
      '请输入第 4 列第 2 张牌',
      '请输入第 4 列第 1 张牌',
      '请输入第 2 列第 2 张牌'
    ],
    cardInfos: [
      '感情现状',
      '不久的将来',
      '对方对我的看法（内在）',
      '对方对我的看法（外在）',
      '对方的状态',
      '对方希望的结果',
      '我的状态',
      '对我的建议'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#f759ab',
    backgroundColor: '#fff0f6',
    icon: '💕'
  }
};